// Official Delta Valley Health Club swim lesson levels (Brentwood only).
// Lessons run 25 minutes. Published activity-block durations are retained pending the final timing check.
export const swimLevels = [
  {
    slug: 'baby-beluga',
    name: 'Baby Beluga',
    classification: 'Beginner',
    level: 'Level 0.5',
    ageRange: '6 mo. – 1 yr.',
    ratio: '5:1',
    color: 'from-purple-200 to-purple-100',
    accent: 'purple',
    icon: '🐋',
    summary: 'A parent-supported introduction to water comfort and safety for babies ages 6 months to 1 year.',
    registrationUrl: null,
    availabilityLabel: 'Coming Soon',
    blocks: [
      { mins: 5, items: ['Sit/hold baby facing you and splash arms with toys', 'Pour water over shoulder → head (hand or cup)'] },
      { mins: 7, items: ['Blow bubbles while baby is watching you', 'Assisted kicks while holding baby'] },
      { mins: 7, items: ['Assisted back floats (support head)', 'Assisted kicks on their back'] },
      { mins: 5, items: ['Intro to wall grabbing', 'Assisted sit jumps'] },
    ],
    levelUpRequirements: ['Has aged out of the group'],
  },
  {
    slug: 'jellyfish',
    name: 'Jellyfish',
    classification: 'Beginner',
    level: 'Level 0.5',
    ageRange: '2 – 4 yr.',
    ratio: '2:1',
    color: 'from-cyan-200 to-cyan-100',
    accent: 'cyan',
    icon: '🪼',
    summary: 'For young swimmers building water comfort, bubbles, kicking, floating, streamlining, and safe pool-entry skills.',
    registrationUrl: 'https://deltavac.clubautomation.com/calendar/event-info?id=931&style=0&isFrame=0',
    availabilityLabel: 'Check Availability',
    blocks: [
      { mins: 5, items: ['Blow bubbles with mouth', 'Kicks on board'] },
      { mins: 7, items: ['Kicks on steps', 'Assisted streamline'] },
      { mins: 7, items: ['Assisted starfish', 'Practice arms on steps'] },
      { mins: 5, items: ['Assisted sit jumps'] },
    ],
    levelUpRequirements: [
      'Can do bubbles with their face in the water',
      'Comfortable in the water',
      'Comfortable on their back with an ear in the water',
      'Can kick on a bar or board independently to the instructor',
      'Can demonstrate streamline form',
      'Has aged out of the group',
    ],
  },
  {
    slug: 'tadpole',
    name: 'Tadpole',
    classification: 'Beginner',
    level: 'Level 1',
    ageRange: '3 – 4 yr.',
    ratio: '2:1',
    color: 'from-emerald-200 to-emerald-100',
    accent: 'emerald',
    icon: '🐸',
    summary: 'For swimmers developing independent floating, short-distance freestyle and backstroke, back breathing, and safe pool exits.',
    registrationUrl: 'https://deltavac.clubautomation.com/calendar/event-info?id=172284&style=0&isFrame=0',
    availabilityLabel: 'Check Availability',
    blocks: [
      { mins: 5, items: ['Kicks on board'] },
      { mins: 7, items: ['Starfish floats', 'Streamline to instructor 3 ft'] },
      { mins: 7, items: ['Assisted freestyle and backstroke'] },
      { mins: 5, items: ['Safety jumps', 'Monkey climb'] },
    ],
    levelUpRequirements: [
      'Has aged out of the group',
      'Can swim freestyle and backstroke 3 ft to the instructor',
      'Can float independently for 5 seconds',
      'Can flip onto their back and use back breathing',
    ],
  },
  {
    slug: 'manatee',
    name: 'Manatee',
    classification: 'Intermediate',
    level: 'Level 1',
    ageRange: '5 yr. +',
    ratio: '3:1',
    color: 'from-teal-200 to-teal-100',
    accent: 'teal',
    icon: '🦭',
    summary: 'For swimmers ages 5 and up learning independent freestyle, backstroke, floating, breathing, and water-safety skills.',
    registrationUrl: 'https://deltavac.clubautomation.com/calendar/event-info?id=943&style=0&isFrame=0',
    availabilityLabel: 'Check Availability',
    blocks: [
      { mins: 5, items: ['Kicks on bar short ways'] },
      { mins: 7, items: ['Streamline push and glide', 'Freestyle w/ arms on bar → short swim on own'] },
      { mins: 7, items: ['Starfish floats', 'Backstroke w/ arms on bar → short swim on own'] },
      { mins: 5, items: ['Safety jumps and monkey climb', 'Rings'] },
    ],
    levelUpRequirements: [
      'Can kick on a bar independently',
      'Can swim freestyle and backstroke independently for 10 yards',
      'Can float on their back for 10 seconds',
      'Comfortable with their face in the water',
      'Can use side breathing and back breathing',
    ],
  },
  {
    slug: 'otter',
    name: 'Otter',
    classification: 'Intermediate',
    level: 'Level 2',
    ageRange: '5 yr. +',
    ratio: '3:1',
    color: 'from-sky-200 to-sky-100',
    accent: 'sky',
    icon: '🦦',
    summary: 'For swimmers moving into the lap pool while developing longer freestyle and backstroke, breaststroke, treading, and diving skills.',
    registrationUrl: 'https://deltavac.clubautomation.com/calendar/event-info?id=172296&style=0&isFrame=0',
    availabilityLabel: 'Check Availability',
    blocks: [
      { mins: 5, items: ['Kick on board halfway (Lap Pool)', 'Starfish or assisted treading (Lap Pool)'] },
      { mins: 7, items: ['Freestyle halfway (Lap Pool)', 'Backstroke halfway (Lap Pool)'] },
      { mins: 7, items: ['Assisted breaststroke → halfway (Lesson Pool)'] },
      { mins: 5, items: ['Assisted sit dives (Lesson Pool)', 'Rings (Lesson Pool)'] },
    ],
    levelUpRequirements: [
      'Can swim breaststroke 10 yards independently in the Lesson Pool',
      'Comfortable in the Lap Pool',
      'Can swim freestyle and backstroke 25 yards in the Lap Pool',
      'Comfortable with sit dives',
      'Must know side breathing before moving into Sea Turtle',
    ],
  },
  {
    slug: 'sea-turtle',
    name: 'Sea Turtle',
    classification: 'Intermediate',
    level: 'Level 3',
    ageRange: '5 yr. +',
    ratio: '3:1',
    color: 'from-blue-200 to-blue-100',
    accent: 'blue',
    icon: '🐢',
    summary: 'For swimmers developing all four strokes, flip turns, diving, treading, and confidence in the deep end.',
    registrationUrl: 'https://deltavac.clubautomation.com/calendar/event-info?id=979&style=0&isFrame=0',
    availabilityLabel: 'Check Availability',
    blocks: [
      { mins: 5, items: ['Kicks on board'] },
      { mins: 7, items: ['Freestyle and backstroke all the way down', 'Breaststroke halfway'] },
      { mins: 7, items: ['Assisted butterfly strokes', 'Assisted flip turns'] },
      { mins: 5, items: ['Dives', 'Treading'] },
    ],
    levelUpRequirements: [
      'Can swim freestyle and backstroke 25 yards in the Lap Pool',
      'Can swim breaststroke 20 yards',
      'Can swim butterfly 12 yards',
      'Starting to tread in 4½ ft water',
      'Comfortable in the deep end',
    ],
  },
  {
    slug: 'orca',
    name: 'Orca',
    classification: 'Advanced',
    level: 'Level 4',
    ageRange: '5 yr. +',
    ratio: '3:1',
    color: 'from-indigo-200 to-indigo-100',
    accent: 'indigo',
    icon: '🐋',
    summary: 'For advanced swimmers refining all four strokes, IM and pull sets, flip turns, diving, and treading.',
    registrationUrl: 'https://deltavac.clubautomation.com/calendar/event-info?id=970&style=0&isFrame=0',
    availabilityLabel: 'Check Availability',
    blocks: [
      { mins: 5, items: ['Kicks on board'] },
      { mins: 7, items: ['FR, BK and BR all the way down', 'Butterfly half → full'] },
      { mins: 7, items: ['IM sets or pull set', 'Flip turns'] },
      { mins: 5, items: ['Dives', 'Treading'] },
    ],
    levelUpRequirements: [
      'Can swim freestyle, breaststroke, and backstroke 25 yards in the Lap Pool',
      'Can swim butterfly 25 yards',
      'Can properly demonstrate a dive',
      'Can perform a proper flip turn',
      'Can complete an IM set',
      'Can complete a pull set',
    ],
  },
  {
    // Shown with the levels at the aquatics team's request (Oct 7); priced in SWIM_PRICING.largeGroup.
    slug: 'advanced-swim-conditioning',
    name: 'Advanced Swim Conditioning',
    classification: 'Advanced',
    level: 'Tryout Required',
    ageRange: '15 yr. & under',
    color: 'from-cyan-200 to-cyan-100',
    accent: 'cyan',
    icon: '🐳',
    summary: 'Competitive swim conditioning in the Lap Pool focused on endurance, stroke refinement, race skills, starts, turns, and all four competitive strokes. 45 minutes, Tuesdays & Thursdays, 4:00–4:45 PM.',
    registrationUrl: null,
    availabilityLabel: 'Tryouts the first Tuesday of each month',
    blocks: [],
    levelUpRequirements: [],
  },
  {
    slug: 'private-lessons',
    name: 'Adult / Private Lessons',
    level: 'Any Level',
    ageRange: '6 months+',
    ratio: '1:1',
    color: 'from-slate-200 to-slate-100',
    accent: 'slate',
    icon: '🏊',
    summary: 'Private instruction for babies, children, and adults at any skill level, from water comfort and breathing to independent freestyle and backstroke.',
    registrationUrl: 'https://deltavac.clubautomation.com/calendar/event-info?id=999&style=0&isFrame=0',
    availabilityLabel: 'Check Availability',
    blocks: [
      { mins: 5, items: ['Kicks on bar with face in the water'] },
      { mins: 7, items: ['Streamline push and glide', 'Freestyle with arms on bar → independently halfway'] },
      { mins: 7, items: ['Assisted back floats (release for 2–3 seconds)', 'Backstroke with arms on bar → independently halfway'] },
      { mins: 5, items: ['Side breathing on bar → independently'] },
    ],
    levelUpRequirements: [],
  },
];

// Pool facts (Brentwood location only)
export const POOL_FACTS = {
  location: 'Brentwood location only',
  pools: [
    { name: 'Lap Pool',          length: '25 yards', temp: '83°F', use: '4 lanes available to members during club hours' },
    { name: 'Lesson/Therapy Pool', length: '15 yards', temp: '93°F', use: 'Swim lessons, physical therapy & scheduled beach parties' },
  ],
};

// Pool weekly schedule (updated 09/03/2026)
export const POOL_SCHEDULE = [
  {
    day: 'Monday',
    activities: [
      { name: 'Lap Swimming', pool: 'Lap Pool', time: '4:30 AM – 9:00 PM', note: 'Open to everyone' },
      { name: 'Seniors Physical Therapy', pool: 'Lesson Pool', time: '4:30 AM – 12:00 PM' },
      { name: 'Family Swim', pool: 'Lap Pool', time: '12:00 PM – 2:00 PM' },
      { name: 'Swim Lessons', pool: 'Lesson Pool', time: '2:30 PM – 7:30 PM', note: 'Swim lessons only' },
    ],
  },
  {
    day: 'Tuesday',
    activities: [
      { name: 'Lap Swimming', pool: 'Lap Pool', time: '4:30 AM – 9:00 PM', note: 'Open to everyone' },
      { name: 'Seniors Physical Therapy', pool: 'Lesson Pool', time: '4:30 AM – 12:00 PM' },
      { name: 'Water Aerobics', pool: 'Lap Pool', time: '10:15 AM – 11:00 AM', note: 'No lane available' },
      { name: 'Family Swim', pool: 'Lap Pool', time: '12:00 PM – 2:00 PM' },
      { name: 'Swim Lessons', pool: 'Lesson Pool', time: '2:30 PM – 7:30 PM', note: 'Swim lessons only' },
      { name: 'Advanced Swim Conditioning', pool: 'Lap Pool', time: '4:00 PM – 4:45 PM', note: 'No lane available' },
    ],
  },
  {
    day: 'Wednesday',
    activities: [
      { name: 'Lap Swimming', pool: 'Lap Pool', time: '4:30 AM – 9:00 PM', note: 'Open to everyone' },
      { name: 'Seniors Physical Therapy', pool: 'Lesson Pool', time: '4:30 AM – 12:00 PM' },
      { name: 'Family Swim', pool: 'Lap Pool', time: '12:00 PM – 2:00 PM' },
      { name: 'Swim Lessons', pool: 'Lesson Pool', time: '2:30 PM – 7:30 PM', note: 'Swim lessons only' },
    ],
  },
  {
    day: 'Thursday',
    activities: [
      { name: 'Lap Swimming', pool: 'Lap Pool', time: '4:30 AM – 9:00 PM', note: 'Open to everyone' },
      { name: 'Seniors Physical Therapy', pool: 'Lesson Pool', time: '4:30 AM – 12:00 PM' },
      { name: 'Water Aerobics', pool: 'Lap Pool', time: '10:15 AM – 11:00 AM', note: 'No lane available' },
      { name: 'Family Swim', pool: 'Lap Pool', time: '12:00 PM – 2:00 PM' },
      { name: 'Swim Lessons', pool: 'Lesson Pool', time: '2:30 PM – 7:30 PM', note: 'Swim lessons only' },
      { name: 'Advanced Swim Conditioning', pool: 'Lap Pool', time: '4:00 PM – 4:45 PM', note: 'No lane available' },
    ],
  },
  {
    day: 'Friday',
    activities: [
      { name: 'Lap Swimming', pool: 'Lap Pool', time: '4:30 AM – 8:00 PM', note: 'Open to everyone' },
      { name: 'Seniors Physical Therapy', pool: 'Lesson Pool', time: '4:30 AM – 12:00 PM' },
      { name: 'Family Swim', pool: 'Lap Pool', time: '12:00 PM – 2:00 PM' },
      { name: 'Swim Lessons', pool: 'Lesson Pool', time: '2:30 PM – 7:00 PM', note: 'Swim lessons only' },
    ],
  },
  {
    day: 'Saturday',
    activities: [
      { name: 'Lap Swimming', pool: 'Lap Pool', time: '6:00 AM – 5:00 PM', note: 'Open to everyone' },
      { name: 'Seniors Physical Therapy', pool: 'Lesson Pool', time: '6:00 AM – 9:00 AM' },
      { name: 'Swim Lessons', pool: 'Lesson Pool', time: '9:30 AM – 2:30 PM', note: 'Swim lessons only' },
      { name: 'No Family Swim', pool: '—', time: '—', note: 'Family swim not scheduled' },
    ],
  },
  {
    day: 'Sunday',
    activities: [
      { name: 'Lap Swimming', pool: 'Lap Pool', time: '6:00 AM – 5:00 PM', note: 'Open to everyone' },
      { name: 'Seniors Physical Therapy', pool: 'Lesson Pool', time: '6:00 AM – 9:00 AM' },
      { name: 'Swim Lessons', pool: 'Lesson Pool', time: '10:00 AM – 1:00 PM', note: 'Swim lessons only' },
      { name: 'No Family Swim', pool: '—', time: '—', note: 'Family swim not scheduled' },
    ],
  },
];

// Pricing (effective 2026) — packages vary by month based on number of weeks
export const SWIM_PRICING = {
  member: {
    group:       { name: 'Group Lesson',  emoji: '🦄', four: 113, five: 140 },
    semiPrivate: { name: 'Semi-Private',  emoji: '🐬', four: 270, five: 336, perChildFour: 135, perChildFive: 168 },
    private:     { name: 'Private Lesson', emoji: '🦈', four: 160, five: 200 },
    largeGroup:  { name: 'Advanced Swim Conditioning',   emoji: '🐳', monthly: 100, schedule: 'Tuesdays & Thursdays · 4:00–4:45 PM' },
  },
  nonMember: {
    group:       { name: 'Group Lesson',  emoji: '🦄', four: 125, five: 155 },
    semiPrivate: { name: 'Semi-Private',  emoji: '🐬', four: 290, five: 360, perChildFour: 145, perChildFive: 180 },
    private:     { name: 'Private Lesson', emoji: '🦈', four: 195, five: 240 },
    largeGroup:  { name: 'Advanced Swim Conditioning',   emoji: '🐳', monthly: 115, schedule: 'Tuesdays & Thursdays · 4:00–4:45 PM' },
  },
};

// Liability / policy clauses — every parent must initial each before signing
export const POLICIES = [
  {
    id: 'makeup',
    title: 'Make-up Policy',
    text: 'A $20.00 fee applies for each make-up class, with a maximum of 2 make-ups per month. Make-ups cannot be rescheduled.',
  },
  {
    id: 'noshow',
    title: 'No-Show Fee',
    text: 'A $5.00 fee applies for any class you fail to attend without notice. Make-up requests must be submitted within the same calendar month — past-month missed lessons cannot be scheduled.',
  },
  {
    id: 'session',
    title: 'Session Changes',
    text: 'Changing from a 5-week session to a 4-week session forfeits the 5th class. Swim instructors are subject to change for both group and private lessons; specific instructors are never guaranteed.',
  },
  {
    id: 'payment',
    title: 'Payment & Refunds',
    text: 'Payment is due at the time of registration. All sales are final — Delta Valley does not refund or credit accounts for any swim lesson purchase. Fees will not be prorated for any reason.',
  },
  {
    id: 'attire',
    title: 'Pool Attire & Accidents',
    text: 'Caps and goggles are recommended but not required. Children who are not potty-trained must wear a swim diaper. Pool accidents will incur a $70.00 cleaning fee.',
  },
  {
    id: 'liability',
    title: 'Assumption of Risk & Release of Liability',
    text: 'I acknowledge swim lessons and pool activities can lead to physical injury. I assume full risk of injury for myself and my child(ren) and release Delta Valley Health Club, its owners, employees, contractors, managers, agents, and affiliates from all liability for personal injury, illness, death, or property damage — including injuries caused by negligence — to the fullest extent allowed under California law. I agree to indemnify and hold DVHC harmless from all claims, including attorneys\' fees and litigation costs.',
  },
];

// Preferred lesson-time slots a parent can multi-select on the registration form.
// Aligned with our actual Lesson Pool schedule (weekday 2:30–7:30 PM, Sat 9:30–2:30, Sun 10–1).
export const PREFERRED_TIME_SLOTS = [
  { id: 'mon-pm-1',  day: 'Monday',    label: 'Mon 3:00 – 5:00 PM',     group: 'Weekday afternoon' },
  { id: 'mon-pm-2',  day: 'Monday',    label: 'Mon 5:00 – 7:00 PM',     group: 'Weekday evening' },
  { id: 'tue-pm-1',  day: 'Tuesday',   label: 'Tue 3:00 – 5:00 PM',     group: 'Weekday afternoon' },
  { id: 'tue-pm-2',  day: 'Tuesday',   label: 'Tue 5:00 – 7:00 PM',     group: 'Weekday evening' },
  { id: 'wed-pm-1',  day: 'Wednesday', label: 'Wed 3:00 – 5:00 PM',     group: 'Weekday afternoon' },
  { id: 'wed-pm-2',  day: 'Wednesday', label: 'Wed 5:00 – 7:00 PM',     group: 'Weekday evening' },
  { id: 'thu-pm-1',  day: 'Thursday',  label: 'Thu 3:00 – 5:00 PM',     group: 'Weekday afternoon' },
  { id: 'thu-pm-2',  day: 'Thursday',  label: 'Thu 5:00 – 7:00 PM',     group: 'Weekday evening' },
  { id: 'fri-pm-1',  day: 'Friday',    label: 'Fri 3:00 – 5:00 PM',     group: 'Weekday afternoon' },
  { id: 'fri-pm-2',  day: 'Friday',    label: 'Fri 5:00 – 7:00 PM',     group: 'Weekday evening' },
  { id: 'sat-am',    day: 'Saturday',  label: 'Sat 9:30 AM – 12:00 PM', group: 'Weekend morning' },
  { id: 'sat-pm',    day: 'Saturday',  label: 'Sat 12:00 – 2:30 PM',    group: 'Weekend afternoon' },
  { id: 'sun-am',    day: 'Sunday',    label: 'Sun 10:00 AM – 1:00 PM', group: 'Weekend morning' },
];
